if (!customElements.get('product-personalisation')) {
  class ProductPersonalisation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('input');
      this.count = this.querySelector('[data-count]');

      this.input.addEventListener('input', () => {
        this.count.textContent = this.input.value.length;
      });
    }
  }
  customElements.define('product-personalisation', ProductPersonalisation);
}
